import { createSelector } from 'reselect'

import { selectGlobalPartnerState } from './selectGlobalPartnerState'

export const selectGlobalPartnerData = createSelector(
  [selectGlobalPartnerState],
  (state) => state.data
)
